import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  homeBreadCrumb: {
    id: 'courseHome.bookmarkTab.breadcrumb.home',
    defaultMessage: 'Home',
    description: 'Home breadcrumb shown on bookmarks page',
  },
  bookmarkBreadCrumb: {
    id: 'courseHome.bookmarkTab.breadcrumb.bookmark',
    defaultMessage: 'Bookmark',
    description: 'Bookmark breadcrumb shown on bookmarks page',
  },
  bookmarkHeading: {
    id: 'courseHome.bookmarkTab.bookmark.heading',
    defaultMessage: 'Bookmarks',
    description: 'Main heading of bookmarks page',
  },
  noBookmarksHeading: {
    id: 'courseHome.bookmarkTab.bookmark.noBookmarks.heading',
    defaultMessage: 'You have not bookmarked any pages yet',
    description: 'Heading shown when there is nothing bookmarked',
  },
  noBookmarksText: {
    id: 'courseHome.bookmarkTab.bookmark.noBookmarks.text',
    defaultMessage: 'Use bookmarks to help you easily return to project pages in this course. Once you click "Bookmark this page" inside of a project, it will display here.',
    description: 'Text shown under heading when there is nothing bookmarked',
  },
  bookmarkDate: {
    id: 'courseHome.bookmarkTab.bookmark.item.date',
    defaultMessage: 'Bookmarked on {date}',
    description: 'Date text shown in bookmarked item box',
  },
  bookmarkView: {
    id: 'courseHome.bookmarkTab.bookmark.item.view',
    defaultMessage: 'View',
    description: 'Text shown on bookmark item view button',
  },
  bookmarkTotal: {
    id: 'courseHome.bookmarkTab.bookmark.item.total',
    defaultMessage: 'Showing {range} out of {count}',
    description: 'Text shown on above bookmark list',
  },
});

export default messages;
